<template>
    <div class="page-content">
        <base-screen>
            <el-form inline  ref="screenForm"
                     :model="screenData"
                     @keydown.native.enter="seachButton"
                     @submit.native.prevent>
                <el-form-item label="标题：">
                    <el-input placeholder="标题" v-model="screenData.title"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="seachButton">查询</el-button>
                    <el-button type="text" @click="resetSearchSubmit">重置</el-button>
                </el-form-item>
            </el-form>
        </base-screen>

        <div class="page-box">
            <el-table :data="data" v-loading="loading"  style="width: 100%" :row-class-name="tableRowClassName" @row-click="rowClick">
                <el-table-column
                  prop="title"
                  label="标题"
                  width="200"
                >
                </el-table-column>
                <el-table-column
                  prop="content"
                  label="内容"
                ></el-table-column>
                <el-table-column
                  prop="readFlag"
                  label="是否已读"
                  width="150"
                >
                    <template slot-scope="{row}">
                        <div v-if="row.readFlag">已读</div>
                        <div v-else>未读</div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
              class="pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNum"
              :page-sizes="[10, 15, 20]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { system } from '../../api'
export default {
  name: 'SysMessage',
  mounted () {
    this.getTableData()
  },
  data () {
    return {
      loading: false,
      screenData: {
        title: '',
        orgCode: this.$store.state.user.orgCode,
        sysUserId: this.$store.state.user.userId
      },
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      data: []
    }
  },

  methods: {
    async getTableData () {
      this.loading = true
      let {data, page} = await system.getSysMessagePage({
        page: this.page,
        param: this.screenData
      })
      this.loading = false
      this.data = data
      this.total = page.total
      this.page.pageNum = page.pageNum
    },
    handleSizeChange (newPageSize) {
      this.page.pageSize = newPageSize
      this.getTableData()
    },
    handleCurrentChange (newPageNo) {
      this.page.pageNum = newPageNo
      this.getTableData()
    },
    seachButton () {
      this.page.pageNum = 1
      this.getTableData()
    },
    resetSearchSubmit () {
      this.$refs.screenForm.resetFields()
      this.page.pageNum = 1
      this.screenData.title = ''
      this.getTableData()
    },
    tableRowClassName ({row}) {
      if (row.readFlag) {
        return 'warning-row'
      } else {
        return ''
      }
    },
    async rowClick (row, event, column) {
      if (!row.readFlag) {
        row.readFlag = true
        let {code, msg} = await system.setSysMessageRead({
          'sysMessageId': row.messageId,
          'orgCode': this.$store.state.user.orgCode,
          'sysUserId': this.$store.state.user.userId
        })
        if (code === 0) {
          await this.$store.dispatch('user/setMessageNum')
        } else {
          this.$message({
            type: 'error',
            message: msg || '设置已读失败'
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/.el-table .warning-row {
    color: #c0c4cc;
  }
</style>
